import { getRandomIntInclusive } from '@application/utils';
import {
  CardItemBreeder, CardItemContainer, Container, HeaderProfile, SectionText, SectionTitle, SideLayoutContentWrapper, SideLayoutSideWrapper,
  SideLayoutStickyWrapper, SideLayoutWrapper,
  SkeletonBox
} from '@presentation/components';
import type { FC } from 'react';
import { useMemo } from 'react';
import * as RootStyled from '../../styled';

export const PageSkeleton: FC = () => {
  const skeletons = useMemo(() => {
    return {
      header: {
        title: 'Vos résultats',
        subtitle: 'Retrouvez ci-dessous les races qui correspondent le plus à vos critères.'
      },
      section: {
        results: Array(getRandomIntInclusive(5, 9)).fill(undefined),
      },
      sideSection: {
        title: {
          width: `${getRandomIntInclusive(40, 50)}%`,
          height: 62,
        },
        text: {
          width: `${getRandomIntInclusive(40, 90)}%`,
          height: 40,
        },
        button: {
          width: `${getRandomIntInclusive(40, 50)}%`,
          height: 30,
        },
      }
    };
  }, []);

  const skeletonSection = useMemo(() => {
    return (skeletons.section.results.map((_, index) => (
      <RootStyled.CardItemWrapper key={index}>
        <CardItemBreeder loading />
      </RootStyled.CardItemWrapper>
    )));
  }, [skeletons.section.results]);

  return (
    <>
      <HeaderProfile
        title={skeletons.header.title}
        subtitle={skeletons.header.subtitle}
      />
      <Container>
          <SideLayoutWrapper>
            <SideLayoutContentWrapper>
              <CardItemContainer>
                {skeletonSection}
              </CardItemContainer>
            </SideLayoutContentWrapper>

            <SideLayoutSideWrapper>
              <SideLayoutStickyWrapper>
                <RootStyled.SideContentWrapper>
                  <SectionTitle><SkeletonBox style={{ ...skeletons.sideSection.title }} /></SectionTitle>
                  <SectionText><SkeletonBox style={{ ...skeletons.sideSection.text }} /></SectionText>
                  <SkeletonBox style={{ ...skeletons.sideSection.button }} />
                </RootStyled.SideContentWrapper>
              </SideLayoutStickyWrapper>
            </SideLayoutSideWrapper>
          </SideLayoutWrapper>
        </Container>
    </>
  );
};
